import { render, staticRenderFns } from "./HmGameVertical.vue?vue&type=template&id=1e9b79f4"
import script from "./HmGameVertical.vue?vue&type=script&lang=js"
export * from "./HmGameVertical.vue?vue&type=script&lang=js"
import style0 from "./HmGameVertical.vue?vue&type=style&index=0&id=1e9b79f4&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports